import { render, staticRenderFns } from "./my_focus_on.vue?vue&type=template&id=fb906620&scoped=true&"
import script from "./my_focus_on.vue?vue&type=script&lang=js&"
export * from "./my_focus_on.vue?vue&type=script&lang=js&"
import style0 from "./my_focus_on.vue?vue&type=style&index=0&id=fb906620&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb906620",
  null
  
)

export default component.exports